import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/components/MainLayout.vue'
import HomePage from '@/components/HomePage.vue'
import LoginUser from '@/components/LoginUser.vue'
import IncomeStatic from '@/components/IncomeStatic.vue'
import IncomeImportRecords from '@/components/IncomeImportRecords.vue'
import ResolveAddress from '@/components/ResolveAddress.vue'
import AdmUser from '@/components/AdmUser.vue'
import { getFirstMenuRoute, hasMenuPermission } from '@/utils/menu'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      meta: {
        requireAuth: false,
        title: '登录'
      },
      component: LoginUser
    },
    {
      path: '/',
      component: MainLayout,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '',
          redirect: '/home'
        },
        {
          path: 'home',
          name: 'Home',
          meta: {
            requireAuth: true,
            title: '首页',
            menuCode: 'HOME'
          },
          component: HomePage
        },
        {
          path: 'income/static',
          name: 'IncomeStatic',
          meta: {
            requireAuth: true,
            title: '投放数据',
            menuCode: 'INCOME_STATIC'
          },
          component: IncomeStatic
        },
        {
          path: 'income/import',
          name: 'IncomeImport',
          meta: {
            requireAuth: true,
            title: '导入记录',
            menuCode: 'INCOME_IMPORT'
          },
          component: IncomeImportRecords
        },
        {
          path: 'resolve/address',
          name: 'ResolveAddress',
          meta: {
            requireAuth: true,
            title: '地址解析',
            menuCode: 'RESOLVE_ADDRESS'
          },
          component: ResolveAddress
        },
        {
          path: 'adm/user',
          name: 'AdmUser',
          meta: {
            requireAuth: true,
            title: '人员管理',
            menuCode: 'ADM_USER'
          },
          component: AdmUser
        },
        {
          path: 'incomeStatic',
          redirect: '/income/static'
        },
        {
          path: 'incomeImportRecords',
          redirect: '/income/import'
        },
        {
          path: 'ResolveAddress',
          redirect: '/resolve/address'
        },
        {
          path: 'users',
          redirect: '/adm/user'
        }
      ]
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requireAuth = to.matched.some(record => record.meta.requireAuth)
  const token = window.localStorage.getItem('oauthToken') || window.sessionStorage.getItem('loginToken')

  if (requireAuth && !token) {
    next('/login')
    return
  }

  if (to.path === '/login' && token) {
    next(getFirstMenuRoute())
    return
  }

  const guardedRoute = to.matched.slice().reverse().find(record => record.meta && record.meta.menuCode)
  if (requireAuth && guardedRoute && !hasMenuPermission(guardedRoute.meta.menuCode)) {
    const redirectPath = getFirstMenuRoute()
    next(redirectPath === to.path ? false : redirectPath)
    return
  }

  next()
})

export default router
